"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorage = void 0;
class LocalStorage {
    getItem(key) {
        try {
            if (typeof window !== 'undefined') {
                return localStorage.getItem(key);
            }
            return null;
        }
        catch (e) {
            throw e;
        }
    }
    setItem(key, value) {
        try {
            if (typeof window !== 'undefined') {
                return localStorage.setItem(key, value);
            }
            return null;
        }
        catch (e) {
            throw e;
        }
    }
    removeItem(key) {
        try {
            if (typeof window !== 'undefined') {
                return localStorage.removeItem(key);
            }
            return null;
        }
        catch (e) {
            throw e;
        }
    }
}
exports.LocalStorage = LocalStorage;
